function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientUserManagement = /*#__PURE__*/function () {
  function ApiClientUserManagement(token) {
    _classCallCheck(this, ApiClientUserManagement);
    this.token = token;
  }
  return _createClass(ApiClientUserManagement, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/users/getUserList', AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "getAccountData",
    value: function getAccountData() {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/users/getAccountList', AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this2.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "getUserEditUserData",
    value: function getUserEditUserData(loginId, contactNo, contactRequestId) {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/users/getUserInfo?loginId=".concat(loginId, "&contactNo=").concat(contactNo, "&&contactRequestId=").concat(contactRequestId), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this3.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "addNewUser",
    value: function addNewUser(newUser) {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/users/createNewUserRole', newUser, AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this4.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "updateEditUser",
    value: function updateEditUser(editUser) {
      var _this5 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/users/updateUser', editUser, AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this5.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this5.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }, {
    key: "deleteUserProfile",
    value: function deleteUserProfile(user) {
      var _this6 = this;
      var promise = new Promise(function (resolve, reject) {
        var newConfig = AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this6.token);
        newConfig.data = user;
        axios.delete('/api/users/removeUser', newConfig).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this6.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /*           Account Management api's below         */

    //get the list of accounts
  }, {
    key: "getAccountListData",
    value: function getAccountListData(customerId) {
      var _this7 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/users/userCustomerList/".concat(customerId), AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this7.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this7.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
    //get default account
  }, {
    key: "getDefaultAccountListData",
    value: function getDefaultAccountListData() {
      var _this8 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/users/getDefaultAccount', AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this8.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this8.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
    //update account info
  }, {
    key: "updateDefaultAccountData",
    value: function updateDefaultAccountData(contactNo, accountNo) {
      var _this9 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post("/api/users/updateDefaultAccount?contactNo=".concat(contactNo, "&accountNo=").concat(accountNo), null, AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this9.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this9.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    //update account info
  }, {
    key: "updateAccountData",
    value: function updateAccountData(accountInfo) {
      var _this0 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.post('/api/users/userCustomerData', accountInfo, AxiosUtils.getConfig(ConfigurationManager.getUSCustomersServiceEndPoint(), _this0.token)).then(function (response) {
          if (response.status === 401) {
            // force user to log in.
            window.location.reload();
          }
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this0.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }]);
}();
export default ApiClientUserManagement;